module.exports = __webpack_public_path__ + "img/size-chart.20d261f8.jpg";